import React, { useEffect } from "react";
import { getOrderSteps } from "./OrderSteps.services";
import { analyticsEvents } from "../../utils/firebaseAnalytics";
import { StepperWithLabel } from "@dishopsaas/design-system";
import { getStepIcons } from "./component/OrderStepIcon";
import { Box } from "@mui/material";
import { useResponsiveMaterial } from "../../hooks/useResponsive";
type OrderStepsProps = {
  order: any;
  activeStep: number;
};

export default function OrderSteps({ order, activeStep }: OrderStepsProps) {
  const { orderType } = order;
  const steps = getOrderSteps(orderType, order?.orderFlowType);
  const icons = getStepIcons(order, orderType);
  const isMobile = useResponsiveMaterial("sm", "down");
  useEffect(() => {
    if (steps[activeStep])
      analyticsEvents.logOrderTracking(activeStep, steps[activeStep]);
  }, [activeStep]);
  return (
    <Box sx={{ padding: "12px 0" }}>
      <StepperWithLabel
        steps={steps}
        activeStep={activeStep + 1}
        stepIcons={icons}
        isMobile={isMobile}
      ></StepperWithLabel>
    </Box>
  );
}
